import { BaseEnum } from "../BaseEnum";

export class Scenario extends BaseEnum {
  static FATTURATO = 1;
  static CICLO_PRODUTTIVO = 2;
  static COSTO_CONSUMI = 3;
  static COSTO_DEL_LAVORO = 4;
  static TASSI_DI_INTERESSE = 5;
  static DISTRIBUZIONI_UTILI = 6;
  static AMMORTAMENTI = 7;
  static RIMODULAZIONE_NUOVI_INVESTIMENTI = 8;
  static AUMENTI_DI_CAPITALE = 9;
  static NUOVI_FINANZIAMENTI = 10;
  static RIMODULAZIONE_INVESTIMENTI_E_FINANZIAMENTI = 11;

  static Codes = [
    this.FATTURATO,
    this.CICLO_PRODUTTIVO,
    this.COSTO_CONSUMI,
    this.COSTO_DEL_LAVORO,
    this.TASSI_DI_INTERESSE,
    this.DISTRIBUZIONI_UTILI,
    this.AMMORTAMENTI,
    this.RIMODULAZIONE_NUOVI_INVESTIMENTI,
    this.AUMENTI_DI_CAPITALE,
    this.NUOVI_FINANZIAMENTI,
    this.RIMODULAZIONE_INVESTIMENTI_E_FINANZIAMENTI,
  ];

  static _labelKeys = [
    "Fatturato",
    "Ciclo Produttivo",
    "Costo Consumi",
    "Costo del Lavoro",
    "Tassi di Interesse",
    "Distribuzioni Utili",
    "Ammortamenti",
    "Rimodulazione Nuovi Investimenti",
    "Aumenti di Capitale",
    "Nuovi Finanziamenti",
    "Rimodulazione Investimenti e Finanziamenti",
  ];
}
